module.exports = __webpack_public_path__ + "static/mansion-8c59c20634cd8078a6d4a9dc226ac745.webp";